module.exports = __webpack_public_path__ + "media/images/about_us_3-d83dcb7d6411d0de6e6f2fffe28b9643.webp";